import { render, staticRenderFns } from "./aboutTpl.vue?vue&type=template&id=c9de63a0&"
import script from "./aboutTpl.vue?vue&type=script&lang=js&"
export * from "./aboutTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports